import {
  Amount,
  Card,
  CardBody,
  COLOR,
  getColorClassName,
  Inline,
  LineBreak,
  Link,
  Paragraph,
  Separator,
} from "@george-labs.com/design-system"
import { PalOfferDTO } from "@smartx/mikro-vt-client-api"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import { useAppDispatch } from "../../app/hooks"
import { setOffer } from "../../app/slices/offersSlice"
import Ellipsis from "../../functions/Ellipsis"
import { getDateDiffInDays } from "../../functions/helpers"
import { useOfferScreenFlow } from "../../hooks/useOfferScreenFlow"

interface IOfferItemProps {
  item: PalOfferDTO
}

export const OfferItem: FC<IOfferItemProps> = ({ item }) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { goToNextOfferScreen } = useOfferScreenFlow()

  const navToOffer = (offer: PalOfferDTO) => {
    dispatch(setOffer(offer))
    goToNextOfferScreen(null, offer.sourceId, true)
  }

  return (
    <Card nested={false}>
      <CardBody
        style={{
          backgroundImage: item.productPictureUrl,
          backgroundPosition: "center",
          height: "150px",
        }}
      />
      <CardBody>
        <Paragraph className="pb-2"></Paragraph>
        <Paragraph style={{ height: "4.5em" }} className="mb-2">
          <Inline emphasis>
            <Ellipsis text={item.subProductName} />
          </Inline>
        </Paragraph>
        <Inline
          className={getColorClassName(COLOR.GRAY_400, { foreground: true })}
        >
          {t("offers.offerCard.offer")}
        </Inline>
      </CardBody>
      <Separator />
      <CardBody>
        <Paragraph small>
          <Inline emphasis>{t("offers.offerCard.validTo")}</Inline>
          <LineBreak />
          <Inline>
            {t("offers.offerCard.validTo1")} {getDateDiffInDays(item.validTo)}{" "}
            {t("offers.offerCard.validTo2")}
          </Inline>
        </Paragraph>
        <Paragraph small>
          <Inline emphasis>{t("offers.offerCard.amount")}</Inline>
          <LineBreak />
          <Inline>
            <Amount
              isAppendedCurrency
              value={item.maxAmount}
              precision={0}
              appendedText="Ft"
              thousandSeparator=" "
              inheritFontWeight={true}
            />
          </Inline>
        </Paragraph>
      </CardBody>
      <Separator />
      <CardBody>
        <Link onClick={() => navToOffer(item)}>{t("common.button.next")}</Link>
      </CardBody>
    </Card>
  )
}
